/**
 * The layout key list, and the `Layout` union derived from it.
 *
 * This lives here — JSX-free, importing nothing — rather than being derived
 * from the `LAYOUTS` registry, because the registry is a map of `.tsx`
 * components. `types/schemas.ts` needs the key list as a *value* (to build
 * `z.enum`), and `clipScenePropsSchema` is imported as a value by
 * `packages/server/remotion/renderChunk.ts`. Deriving the keys from the
 * registry therefore pulled every layout component — and transitively
 * `BarsVisualization.tsx`, which reads `offsetWidth` — into the type graph of
 * `packages/server`, `packages/api` and `apps/trigger`, forcing `lib: ["dom"]`
 * onto three Node-only packages.
 *
 * `layouts/index.ts` asserts at compile time that the registry and this list
 * still agree, so adding a layout in one place and not the other is a build
 * error rather than a runtime surprise.
 */
export const LAYOUT_KEYS = [
  // AUDIO_LAYOUTS
  'avatar',
  'bigTitle',
  'block',
  'chatbox',
  'edgy',
  'framed',
  'postcard',
  'scriptLarge',
  'scriptSmall',
  'selfPortrait',
  // VIDEO_LAYOUTS
  'captions',
  'meme',
  'translucent',
] as const

export type Layout = (typeof LAYOUT_KEYS)[number]
